document.addEventListener('DOMContentLoaded', () => {
    const fields = document.querySelectorAll('.gfield input, .gfield textarea');

    fields.forEach((field, index) => {

        const gfield = field.closest('.gfield');
        const description = gfield?.querySelector('.gfield_description');

        if (description) {
            console.log(`Description trouvée pour le champ ${index + 1}:`, description);

            const toggleClass = () => {
                if (field.value.trim() !== '' || field === document.activeElement) {
                    description.classList.add('floating');
                } else {
                    description.classList.remove('floating');
                }
            };

            toggleClass();

            field.addEventListener('focus', toggleClass);
            field.addEventListener('blur', toggleClass);
            field.addEventListener('input', toggleClass);
        }
    });
});